// src/reducers/faultyCountReducer.js
import {
  GET_FAULTYCOUNT_REQUEST,
  GET_FAULTYCOUNT_SUCCESS,
  GET_FAULTYCOUNT_FAILURE
} from 'src/actions/faultyCountActions';

const initialState = 0; // direkt ett nummer, inte objekt

const faultyCountReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FAULTYCOUNT_REQUEST:
      return 0; // nollställ medan vi hämtar
    case GET_FAULTYCOUNT_SUCCESS:
      return action.payload; // spara antalet direkt i state
    case GET_FAULTYCOUNT_FAILURE:
      return 0; // fallback vid fel
    default:
      return state;
  }
};

export default faultyCountReducer;